import React from 'react';
import { useUser } from '@/providers';
import ConsolidatedBilling from './ConsolidatedBilling';
import PersonalBilling from './PersonalBilling';

const Billing = () => {
  const user = useUser();

  if (user.billing_account_id) {
    return <ConsolidatedBilling />;
  }
  return <PersonalBilling />;
};

export default Billing;
